import {ApartmentOutlined, ArrowUpOutlined, BranchesOutlined, CheckCircleOutlined, CloseSquareOutlined, DownloadOutlined, DownOutlined, FullscreenOutlined, LeftOutlined, LoadingOutlined, MenuOutlined, ReloadOutlined, RightOutlined, SwapOutlined, UploadOutlined} from "@ant-design/icons";
import {Badge, Breadcrumb, Button, Card, Checkbox, Descriptions, Dropdown, Form, Input, MenuProps, message, Modal, Popover, Select, Spin, Switch, Table, Tabs, TabsProps, Tag, Upload} from "antd";
import {useForm} from "antd/es/form/Form";
import React, {memo, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {AppContextContext, AttributeDefinitionServiceContext, ClientNotificationServiceContext, SbomComponentServiceContext, SbomProjectServiceContext, SbomProjectVersionServiceContext} from "../../Contexts";
import {ServerConstraintViolationsHolder} from "../../sal-ui/ServerConstraintViolations";
import {DocumentTitle} from "../DocumentTitle";
import * as globalStyles from "../App.module.css";
import QueryOptions from "../../sal-ui/QueryOptions";
import SbomProjectVersion from "../../domain/SbomProjectVersion";
import PagedResult from "../../service/PagedResult";
import * as styles from "./SbomProjectVersionDetail.module.css";
import {ColumnsType} from "antd/es/table";
import SbomComponent from "../../domain/SbomComponent";
import VulSourceItemPreview from "../vulsourceitem/VulSourceItemPreview";
import {formatDate, formatDateTime} from "../../utils/FormatUtils";
import AttributeDefinition from "../../domain/AttributeDefinition";
import {TableHandler, TableUiConfig, useTableHandler} from "../../sal-ui/TableHandler";
import {ascendingFirstSortDirections, descendingFirstSortDirections} from "../../sal-ui/TableSortDirections";
import FindingStatistics from "./FindingStatistics";
import VulnerabilitiesLabel from "./VulnerabilitiesLabel";
import FindingCount from "./FindingCount";
import SbomProjectVersionComponentFilter, {createDefaultSbomProjectVersionComponentFilterValues} from "./SbomProjectVersionComponentFilter";
import _ from "lodash";
import {FindingSeverity, getEqualOrGreaterSeverities} from "../../domain/FindingSeverity";
import {isColumnVisible, TableConfig} from "../tableconfig/TableConfig";
import SbomComponentFinding from "../../domain/SbomComponentFinding";
import * as tackStyles from "../vulsourceitem/Tack.module.css";
import * as sealScoreStyles from "../vulsourceitem/SealScore.module.css";
import FindingAnalysisStatistics, {AnalysisStyle} from "./FindingAnalysisStatistics";
import Collapse from "@kunukn/react-collapse";
import MoreLess from "../common/MoreLess";
import {PackageURL} from 'packageurl-js';
import SbomProjectVersionVulnerableComponentFilter, {createDefaultSbomProjectVersionVulnerableComponentFilterValues} from "./SbomProjectVersionVulnerableComponentFilter";
import {Permission} from "../../domain/auth/Permission";
import SingleResult from "../../service/SingleResult";
import SbomProject from "../../domain/SbomProject";
import {colorForSbomProjectVersionStatus, formatSbomProjectVersionStatus, SbomProjectVersionStatus} from "../../domain/SbomProjectVersionStatus";
import {evaluateSbomComponentHealth, SbomComponentHealth} from "../../domain/SbomComponentHealth";
import {green, orange, red} from '@ant-design/colors';
import {SoftwareLicenseOrigin} from "../../domain/SoftwareLicenseOrigin";
import {packageUrlSupportedByDepsDev, packageUrlToOsiUrl} from "../sbomcomponent/functions";
import SbomComponentSourcePackageTag from "../sbomcomponent/SbomComponentSourcePackageTag";
import {formatSbomType} from "../../domain/SbomType";
import SoftwareLicense from "../../domain/SoftwareLicense";
import CompareModal from "./CompareModal";
import AdoptAnalysisModal from "./AdoptAnalysisModal";
import FindingStatusCollapse from "./FindingStatusCollapse";
import {FaDebian, FaUbuntu} from "react-icons/fa6";
import {FormPersister} from "../../sal-ui/FormPersister";
import {ComponentFindingsPage} from "./FocusedFindingSelect";
import FocusedFindingModal from "./FocusedFindingModal";
import FindingStatisticsImpact from "./FindingStatisticsImpact";
import {useFocusedFindingAnalysis} from "./useFocusedFindingAnalysis";
import {useFocusedFindingUrlSync} from "./useFocusedFindingUrlSync";
import {SBOM_VULNERABLE_TAB_HASH} from "../../domain/SbomUiUrls";
import UsageGraphModal from "./UsageGraphModal";

const serverViolationsHolder = new ServerConstraintViolationsHolder();

const defaultVisibleColumns = ["type", "group", "name", "version", "publishedAt", "licenses", "analysisStatistics", "findingStatistics", "actions"];

const defaultTableUiConfig = {immediateMode: true, visibleColumns: defaultVisibleColumns, showAiAnalytics: true};
const focusedComponentOptionLoadMoreThresholdPx = 24;
const focusedAnalysisPageSize = 25;
const filterDebounceMs = 500;
const componentFindingsPageSize = focusedAnalysisPageSize;
const focusedFindingOptionPageSize = focusedAnalysisPageSize;
const focusedNavigationComponentsPageSize = focusedAnalysisPageSize;
const focusedNavigationComponentsOrderBy = "name asc, id asc";
const vulnerableComponentsFixedRqbQuery = {
    combinator: "and",
    rules: [{field: "severity", operator: "in", value: getEqualOrGreaterSeverities(FindingSeverity.UNKNOWN)}]
};

const duplicateComponentsFixedRqbQuery = {
    combinator: "and",
    rules: [{field: "duplicate", operator: "eq", value: true}]
};

const unknownLicensesFixedRqbQuery = {
    combinator: "and",
    rules: [{field: "licenses", operator: "unknownLicenses"}]
};

const outdatedComponentsFixedRqbQuery = {
    combinator: "and",
    rules: [{field: "latestVersion", operator: "outdated"}]
};

const knownConditionalComponentTabs = [SBOM_VULNERABLE_TAB_HASH, "duplicate", "unknownLicenses", "outdated"];

const layout = {
    labelCol: {span: 6},
    wrapperCol: {span: 18},
};

const tailLayout = {
    wrapperCol: {offset: 6, span: 18},
};

function createRqbQuery(values: any) {
    const rqbQuery = {
        combinator: "and",
        rules: []
    };

    if (values.severity && values.severity.length > 0) {
        rqbQuery.rules.push({
            field: "severity",
            operator: "in",
            value: getEqualOrGreaterSeverities(values.severity)
        });
    }

    if (values.licenses && values.licenses.length > 0) {
        rqbQuery.rules.push({
            field: "license_keys",
            operator: "arrayIn",
            value: values.licenses
        });
    }

    if (values.name) {
        rqbQuery.rules.push({
            field: "name",
            operator: "icontains",
            value: values.name
        });
    }

    if (values.hideNotAffected) {
        rqbQuery.rules.push({
            field: "analysedFindingStatistics",
            operator: "hideNotAffected",
        });
    }

    if (values.hideAnalysed) {
        rqbQuery.rules.push({
            field: "analysisStatistics",
            operator: "hideAnalysed"
        });
    }

    if (values.onlyDirect) {
        rqbQuery.rules.push({
            field: "directDependency",
            operator: "eq",
            value: true
        });
    }

    return rqbQuery;
}

const ProjectVersionLicenses = function ({sbomProjectVersion}: { sbomProjectVersion?: SbomProjectVersion }) {
    if (sbomProjectVersion?.licenses === undefined) {
        return null;
    }

    if (sbomProjectVersion?.licenses?.length === 0) {
        return <i>no licenses</i>;
    }

    return <MoreLess textMore={"« show more licenses »"} textLess={"» hide licenses «"}>
        {sbomProjectVersion?.licenses.map(license => {
            if (license.origin === SoftwareLicenseOrigin.UNKNOWN) {
                return <div key={license.shortName} className={styles['license-status']}>
                    {license.shortName} {sbomProjectVersion?.project?.softwareLicensePolicy && <Badge count={<CloseSquareOutlined/>} style={{color: '#f5222d'}}/>}
                </div>;
            }

            return <div key={license.shortName} className={styles['license-status']}>
                <Link to={`/software-licenses/${license.id}`} target={"_blank"}>{license.shortName}</Link>

                {sbomProjectVersion?.project?.softwareLicensePolicy && <>
                    {sbomProjectVersion?.licenseViolations?.includes(license.licenseKey) && <Badge count={<CloseSquareOutlined/>} style={{color: '#f5222d'}}/>}
                    {!sbomProjectVersion?.licenseViolations?.includes(license.licenseKey) && <Badge count={<CheckCircleOutlined/>} style={{color: '#52c41a'}}/>}
                </>}
            </div>;
        })}
    </MoreLess>;
};

interface ComponentFilterState {
    values: any;
    setValues: (values: any) => void;
}

function SbomProjectVersionDetail() {
    const persistentIdent = 'SbomProjectVersionDetail';
    const appContext = useContext(AppContextContext);
    const sbomProjectService = useContext(SbomProjectServiceContext);
    const sbomProjectVersionService = useContext(SbomProjectVersionServiceContext);
    const sbomComponentService = useContext(SbomComponentServiceContext);
    const attributeDefinitionService = useContext(AttributeDefinitionServiceContext);
    const clientNotificationService = useContext(ClientNotificationServiceContext);
    const filterFormPersisters = useMemo(() => ({
        all: new FormPersister(`${persistentIdent}.filter.all`),
        vulnerable: new FormPersister(`${persistentIdent}.filter.${SBOM_VULNERABLE_TAB_HASH}`),
        duplicate: new FormPersister(`${persistentIdent}.filter.duplicate`),
        unknownLicenses: new FormPersister(`${persistentIdent}.filter.unknownLicenses`),
        outdated: new FormPersister(`${persistentIdent}.filter.outdated`),
    }), [persistentIdent]);
    const location = useLocation();
    const navigate = useNavigate();
    const {sbomProjectVersionId}: any = useParams();
    const sbomProjectVersionIdRef = useRef<string>(sbomProjectVersionId);
    const [editMode, setEditMode] = useState(false);
    const [sbomProject, setSbomProject] = useState<SingleResult<SbomProject>>();
    const [sbomProjectVersion, setSbomProjectVersion] = useState<SbomProjectVersion>();
    const [sbomComponents, setSbomComponents] = useState<PagedResult<SbomComponent>>();
    const [vulnerableSbomComponents, setVulnerableSbomComponents] = useState<PagedResult<SbomComponent>>();
    const [duplicateComponents, setDuplicateComponents] = useState<PagedResult<SbomComponent>>();
    const [unknownLicensesComponents, setUnknownLicensesComponents] = useState<PagedResult<SbomComponent>>();
    const [outdatedComponents, setOutdatedComponents] = useState<PagedResult<SbomComponent>>();
    const [attributeDefinitions, setAttributeDefinitions] = useState<AttributeDefinition[]>();
    const [activeComponentsTab, setActiveComponentsTab] = useState<string>();
    const activeComponentsTabRef = useRef<string>();
    const [filterValues, setFilterValues] = useState<any>(() => loadFilterValues(filterFormPersisters.all, createDefaultSbomProjectVersionComponentFilterValues()));
    const [vulnerableFilterValues, setVulnerableFilterValues] = useState<any>(() => loadFilterValues(filterFormPersisters.vulnerable, createDefaultSbomProjectVersionVulnerableComponentFilterValues()));
    const [duplicateFilterValues, setDuplicateFilterValues] = useState<any>(() => loadFilterValues(filterFormPersisters.duplicate, createDefaultSbomProjectVersionComponentFilterValues()));
    const [unknownLicensesFilterValues, setUnknownLicensesFilterValues] = useState<any>(() => loadFilterValues(filterFormPersisters.unknownLicenses, createDefaultSbomProjectVersionComponentFilterValues()));
    const [outdatedFilterValues, setOutdatedFilterValues] = useState<any>(() => loadFilterValues(filterFormPersisters.outdated, createDefaultSbomProjectVersionComponentFilterValues()));
    const [usageModalOpen, setUsageModalOpen] = useState(false);
    const [usageGraphData, setUsageGraphData] = useState<any>();
    const [usageModalTitle, setUsageModalTitle] = useState("");
    const [adoptModalOpen, setAdoptModalOpen] = useState(false);
    const [compareModalOpen, setCompareModalOpen] = useState(false);
    const [versions, setVersions] = useState<PagedResult<SbomProjectVersion>>();
    const [moreInfoOpen, setMoreInfoOpen] = useState(false);
    const focusedAnalysisScope = useFocusedFindingAnalysis({
        projectVersionId: sbomProjectVersionId,
        componentFindingsPageSize,
        findingOptionPageSize: focusedFindingOptionPageSize,
        navigationComponentsPageSize: focusedNavigationComponentsPageSize,
        componentOptionLoadMoreThresholdPx: focusedComponentOptionLoadMoreThresholdPx,
        navigationComponentsOrderBy: focusedNavigationComponentsOrderBy,
        vulnerableComponentsRqbQuery: vulnerableComponentsFixedRqbQuery
    });
    const focusedAnalysis = focusedAnalysisScope.controller;

    useFocusedFindingUrlSync({
        projectVersionId: sbomProjectVersionId,
        analysis: focusedAnalysisScope.urlSync
    });

    const tableHandler = useTableHandler("name asc", {
        reloadFunction: reloadComponents,
        initialPageSize: 25,
        persistentIdent: `${persistentIdent}`
    });

    const vulnerableTableHandler = useTableHandler("name asc", {
        reloadFunction: reloadVulnerableComponents,
        initialPageSize: 25,
        persistentIdent: `${persistentIdent}`,
        fixedRqbQuery: vulnerableComponentsFixedRqbQuery
    });

    const duplicateTableHandler = useTableHandler("name asc", {
        reloadFunction: reloadDuplicateComponents,
        initialPageSize: 25,
        persistentIdent: `${persistentIdent}`,
        fixedRqbQuery: duplicateComponentsFixedRqbQuery
    });

    const unknownLicensesTableHandler = useTableHandler("name asc", {
        reloadFunction: reloadUnknownLicenseComponents,
        initialPageSize: 25,
        persistentIdent: `${persistentIdent}`,
        fixedRqbQuery: unknownLicensesFixedRqbQuery
    });

    const outdatedTableHandler = useTableHandler("name asc", {
        reloadFunction: reloadOutdatedComponents,
        initialPageSize: 25,
        persistentIdent: `${persistentIdent}`,
        fixedRqbQuery: outdatedComponentsFixedRqbQuery
    });
    const [tableUiConfig, setTableUiConfig] = useState<TableUiConfig>(() => tableHandler.loadUiConfig() || defaultTableUiConfig);

    const columns: ColumnsType<SbomComponent> = [
        {
            dataIndex: "type",
            title: "Type",
            width: 100,
            align: "center",
            render: renderType
        },
        {
            dataIndex: "group",
            title: "Group",
        },
        {
            dataIndex: "name",
            title: "Name",
            sorter: true,
            defaultSortOrder: "ascend",
            sortDirections: ascendingFirstSortDirections,
            render: renderName
        },
        {
            dataIndex: "version",
            title: "Version",
            render: renderVersion
        },
        {
            dataIndex: "publishedAt",
            title: "Published at",
            width: 160,
            align: "center",
            sorter: true,
            sortDirections: descendingFirstSortDirections,
            render: renderPublishedAt
        },
        {
            dataIndex: "licenses",
            title: "Licenses",
            render: renderLicenses
        },
        {
            dataIndex: "analysisStatistics",
            title: "Analysis",
            align: "center",
            render: renderAnalysisStatistics
        },
        {
            dataIndex: "findingStatistics",
            title: "Vulnerability findings",
            render: renderFindingStatisticsColumn
        },
        {
            dataIndex: "actions",
            title: "Actions",
            width: 80,
            align: "center",
            render: renderAction
        }
    ];

    const debouncedOnFinishFilter = useMemo(() => _.debounce(onFinishFilter, filterDebounceMs), []);
    const debouncedOnFinishVulnerableFilter = useMemo(() => _.debounce(onFinishVulnerableFilter, filterDebounceMs), []);
    const debouncedOnFinishDuplicateFilter = useMemo(() => _.debounce(onFinishDuplicateFilter, filterDebounceMs), []);
    const debouncedOnFinishUnknownLicensesFilter = useMemo(() => _.debounce(onFinishUnknownLicensesFilter, filterDebounceMs), []);
    const debouncedOnFinishOutdatedFilter = useMemo(() => _.debounce(onFinishOutdatedFilter, filterDebounceMs), []);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        attributeDefinitionService.getList(QueryOptions.newUnlimitedOrderedInstance("name")).then(value => setAttributeDefinitions(value.data));

        restoreFilterQueries();
    }, []);

    useEffect(() => {
        if (sbomProjectVersionId === undefined) {
            return;
        }

        sbomProjectVersionIdRef.current = sbomProjectVersionId;

        resetCurrentComponentsTab();
        clearComponentData();

        reloadActiveComponents(true);

        clientNotificationService.subscribe("seal:SBOM_PROJECT_VERSION_EVALUATION_COMPLETED", () => onEvaluationCompleted(), sbomProjectVersionId);
        clientNotificationService.subscribe("seal:SBOM_PROJECT_VERSION_PUBLISHED_AT_UPDATE_COMPLETED", () => onPublishedAtUpdateCompleted(), sbomProjectVersionId);
        clientNotificationService.subscribe("seal:SBOM_PROJECT_VERSION_FINDINGS_UPDATED", () => onFindingsUpdated(), sbomProjectVersionId);

        return function cleanup() {
            clientNotificationService.unsubscribe("seal:SBOM_PROJECT_VERSION_EVALUATION_COMPLETED", sbomProjectVersionId);
            clientNotificationService.unsubscribe("seal:SBOM_PROJECT_VERSION_PUBLISHED_AT_UPDATE_COMPLETED", sbomProjectVersionId);
            clientNotificationService.unsubscribe("seal:SBOM_PROJECT_VERSION_FINDINGS_UPDATED", sbomProjectVersionId);
        };
    }, [sbomProjectVersionId]);

    useEffect(() => {
        if (sbomProject === undefined) {
            return;
        }

        sbomProjectVersionService.getList(sbomProject.data.id, QueryOptions.newUnlimitedOrderedInstance("name desc")).then(setVersions);
    }, [sbomProject]);

    useEffect(() => {
        return function cleanup() {
            debouncedOnFinishFilter.cancel();
            debouncedOnFinishVulnerableFilter.cancel();
            debouncedOnFinishDuplicateFilter.cancel();
            debouncedOnFinishUnknownLicensesFilter.cancel();
            debouncedOnFinishOutdatedFilter.cancel();
        };
    }, [
        debouncedOnFinishFilter,
        debouncedOnFinishVulnerableFilter,
        debouncedOnFinishDuplicateFilter,
        debouncedOnFinishUnknownLicensesFilter,
        debouncedOnFinishOutdatedFilter
    ]);

    const closeUsageModalCallback = useCallback(() => setUsageModalOpen(false), []);

    const editCancelCallback = useCallback(() => setEditMode(false), []);

    const editFinishCallback = useCallback(() => {
        setEditMode(false);

        reload();
    }, []);

    const canRead = appContext.user.hasPermission(Permission.SBOM_PROJECT__MANAGE_ORG) || sbomProject?.permissions?.includes(Permission.SBOM_PROJECT__READ);
    const canAnalyze = appContext.user.hasPermission(Permission.SBOM_PROJECT__MANAGE_ORG) || sbomProject?.permissions?.includes(Permission.SBOM_PROJECT__ANALYZE);
    const canManage = appContext.user.hasPermission(Permission.SBOM_PROJECT__MANAGE_ORG) || sbomProject?.permissions?.includes(Permission.SBOM_PROJECT__MANAGE);

    const tabAll = {
        key: 'all',
        label: <>All components <Badge className={styles['count-badge']} showZero={true} overflowCount={10000} count={sbomProjectVersion?.componentsTotal}/></>,
        children: renderActiveComponentTab('all', () => renderComponents({values: filterValues, setValues: setFilterValues}, debouncedOnFinishFilter, tableHandler, sbomComponents, filterFormPersisters.all.ident))
    };

    const tabVulnerable = {
        key: SBOM_VULNERABLE_TAB_HASH,
        label: <>Vulnerable components <Badge className={styles['count-badge']} showZero={true} overflowCount={10000} count={sbomProjectVersion?.componentsVulnerable}/></>,
        children: renderActiveComponentTab(SBOM_VULNERABLE_TAB_HASH, () => renderComponents({values: vulnerableFilterValues, setValues: setVulnerableFilterValues}, debouncedOnFinishVulnerableFilter, vulnerableTableHandler, vulnerableSbomComponents, filterFormPersisters.vulnerable.ident, <SbomProjectVersionVulnerableComponentFilter
                className={styles['filter']}
                values={vulnerableFilterValues}
                onChange={values => {
                    if (_.isEqual(values, vulnerableFilterValues)) {
                        return;
                    }

                    setVulnerableFilterValues(values);

                    debouncedOnFinishVulnerableFilter(values);
                }}
                persistentStateIdent={filterFormPersisters.vulnerable.ident}
                immediateMode={tableUiConfig.immediateMode}
            />
        ))
    };

    const tabDuplicate = {
        key: 'duplicate',
        label: <>Duplicate components <Badge className={styles['count-badge']} showZero={true} overflowCount={10000} count={sbomProjectVersion?.componentsDuplicate}/></>,
        children: renderActiveComponentTab('duplicate', () => renderComponents({values: duplicateFilterValues, setValues: setDuplicateFilterValues}, debouncedOnFinishDuplicateFilter, duplicateTableHandler, duplicateComponents, filterFormPersisters.duplicate.ident))
    };

    const tabUnknownLicenses = {
        key: 'unknownLicenses',
        label: <>Unknown licenses <Badge className={styles['count-badge']} showZero={true} overflowCount={10000} count={sbomProjectVersion?.componentsUnknownLicenses}/></>,
        children: renderActiveComponentTab('unknownLicenses', () => renderComponents({values: unknownLicensesFilterValues, setValues: setUnknownLicensesFilterValues}, debouncedOnFinishUnknownLicensesFilter, unknownLicensesTableHandler, unknownLicensesComponents, filterFormPersisters.unknownLicenses.ident))
    };

    const tabOutdated = {
        key: 'outdated',
        label: <>Outdated components <Badge className={styles['count-badge']} showZero={true} overflowCount={10000} count={sbomProjectVersion?.componentsOutdated}/></>,
        children: renderActiveComponentTab('outdated', () => renderComponents({values: outdatedFilterValues, setValues: setOutdatedFilterValues}, debouncedOnFinishOutdatedFilter, outdatedTableHandler, outdatedComponents, filterFormPersisters.outdated.ident))
    };

    const tabItems: TabsProps['items'] = [];

    if (sbomProjectVersion?.componentsVulnerable > 0) {
        tabItems.push(tabVulnerable);
    }

    if (sbomProjectVersion?.componentsDuplicate > 0) {
        tabItems.push(tabDuplicate);
    }

    if (sbomProjectVersion?.componentsUnknownLicenses > 0) {
        tabItems.push(tabUnknownLicenses);
    }

    if (sbomProjectVersion?.componentsOutdated > 0) {
        tabItems.push(tabOutdated);
    }

    tabItems.push(tabAll);

    return (
        <DocumentTitle title={`Project ${sbomProjectVersion?.project?.name || sbomProjectVersionIdRef.current}: ${sbomProjectVersion?.name}`}>
            <>
                <Breadcrumb
                    className={globalStyles["common__breadcrumb"]}
                    items={[
                        {title: appContext.config?.appName},
                        {title: <Link to={"/sbom-projects"}>Projects</Link>},
                        {title: <Link to={`/sbom-projects/${sbomProjectVersion?.project?.id}`}>{sbomProjectVersion?.project?.name}</Link>},
                        {
                            title: <>
                                {versions === undefined && <>{sbomProjectVersion?.name}</>}
                                {versions && <Select variant={"borderless"}
                                                     className={styles['breadcrumb-version']}
                                                     size={"small"}
                                                     defaultValue={sbomProjectVersionIdRef.current}
                                                     popupMatchSelectWidth={false}
                                                     onChange={value => navigate(`/sbom-projects/${sbomProject.data.id}/${value}${location.hash}`)}
                                                     options={versions?.data?.map(version => ({
                                                         label: version.name,
                                                         value: version.id
                                                     }))}
                                />}
                            </>
                        }
                    ]}
                />

                <Spin spinning={!sbomProjectVersion} indicator={<LoadingOutlined style={{fontSize: 24}} spin={true}/>}>
                    <UsageGraphModal
                        open={usageModalOpen}
                        title={usageModalTitle}
                        graphData={usageGraphData}
                        onClose={closeUsageModalCallback}
                    />

                    <FocusedFindingModal
                        analysis={focusedAnalysis}
                        sbomProject={sbomProject}
                        projectVersion={sbomProjectVersion}
                        attributeDefinitions={attributeDefinitions}
                        showAiAnalytics={tableUiConfig.showAiAnalytics ?? true}
                        canOpenFinding={canAnalyze || canManage}
                        onShowUsagesClick={onShowUsagesClick}
                        onFindingStatusSave={onFindingStatusSave}
                        onShowAiAnalyticsChange={showAiAnalytics => updateTableUiConfig({...tableUiConfig, showAiAnalytics})}
                    />

                    <HeaderTitle sbomProjectVersion={sbomProjectVersion}/>

                    <HeaderCards
                        sbomProjectVersion={sbomProjectVersion}
                        moreInfoOpen={moreInfoOpen}
                        onToggleMoreInfo={() => setMoreInfoOpen(!moreInfoOpen)}
                        actionsDropdown={(canRead || canManage) ? <ActionsDropdown
                            canManage={canManage}
                            canAnalyze={canAnalyze}
                            canRead={canRead}
                            sbomProjectVersion={sbomProjectVersion}
                            onEdit={() => setEditMode(!editMode)}
                            onDelete={() => {
                                Modal.confirm({
                                    content: "Do you really want to delete this project version?",
                                    okText: "Delete",
                                    cancelText: "Cancel",
                                    okButtonProps: {danger: true},
                                    onOk: () => onDeleteConfirm()
                                });
                            }}
                            onImport={handleImport}
                            onDownload={onDownloadBom}
                            onEvaluate={() => {
                                Modal.confirm({
                                    title: "Evaluation of components",
                                    content: "Do you really want to re-evaluate vulnerability of components?",
                                    okText: "Evaluate",
                                    cancelText: "Cancel",
                                    onOk: () => evaluateComponents()
                                });
                            }}
                            onAdopt={() => setAdoptModalOpen(true)}
                            onCompare={() => setCompareModalOpen(true)}
                        /> : null}
                    />

                    <EditForm sbomProjectVersion={sbomProjectVersion} editMode={editMode} onCancel={editCancelCallback} onFinish={editFinishCallback}/>

                    <MoreInfoPanel sbomProjectVersion={sbomProjectVersion} canManage={canManage} open={moreInfoOpen}/>

                    <ComponentTabs
                        items={tabItems}
                        activeKey={activeComponentsTab}
                        onChange={onComponentsTabChange}
                    />
                </Spin>

                <AdoptAnalysisModal open={adoptModalOpen}
                                    sbomProjectId={sbomProjectVersion?.project?.id}
                                    sbomProjectVersionId={sbomProjectVersionIdRef.current}
                                    onClose={() => {
                                        setAdoptModalOpen(false);

                                        reloadActiveComponents();
                                    }}
                />

                <CompareModal open={compareModalOpen}
                              sbomProjectId={sbomProjectVersion?.project?.id}
                              sbomProjectVersionId={sbomProjectVersionIdRef.current}
                              onClose={() => {
                                  setCompareModalOpen(false);
                              }}
                />
            </>
        </DocumentTitle>
    );

    function renderExpandedComponent(sbomComponent: SbomComponent) {
        const findingsPage = focusedAnalysis.componentsFindings[sbomComponent.id];

        return <div className={styles['component-findings']}>
            <h2>Vulnerability items for {sbomComponent.name} {sbomComponent.version}</h2>

            {findingsPage === undefined && <Spin/>}
            {findingsPage?.data.map(finding => {
                return renderFindingCard(sbomComponent, finding);
            })}
            {findingsPage && renderComponentFindingsPagination(sbomComponent, findingsPage)}
        </div>;
    }

    function renderComponentFindingsPagination(sbomComponent: SbomComponent, findingsPage: ComponentFindingsPage) {
        if (findingsPage.total <= findingsPage.top) {
            return null;
        }

        const first = findingsPage.skip + 1;
        const last = findingsPage.skip + findingsPage.data.length;
        const firstFinding = findingsPage.data[0];

        return <div className={styles['component-findings-pagination']}>
            <Button size={"small"}
                    icon={<LeftOutlined/>}
                    disabled={findingsPage.skip === 0}
                    onClick={() => focusedAnalysis.reloadComponentFindings(sbomComponent.id, Math.max(0, findingsPage.skip - findingsPage.top), findingsPage.sort)}/>
            <span>{first}-{last} of {findingsPage.total}</span>
            <Button size={"small"}
                    icon={<RightOutlined/>}
                    disabled={last >= findingsPage.total}
                    onClick={() => focusedAnalysis.reloadComponentFindings(sbomComponent.id, findingsPage.skip + findingsPage.top, findingsPage.sort)}/>
            {firstFinding && <span className={styles['component-findings-pagination-note']}>
                This component has many findings. Open focused view for easier browsing
                <Button
                    className={"btn-seamless"}
                    size={"small"}
                    icon={<FullscreenOutlined/>}
                    title={"Open focused view"}
                    onClick={event => {
                        event.stopPropagation();

                        focusedAnalysis.open(sbomComponent, firstFinding);
                    }}
                />
            </span>}
        </div>;
    }

    function renderFindingCard(sbomComponent: SbomComponent, finding: SbomComponentFinding) {
        const findingTitle = finding.vulSourceItem?.attributes?.title || finding.vulSourceItem?.attributes?.description;
        const canOpenFinding = canAnalyze || canManage;

        return <Card key={finding.id} className={sealScoreStyles['severity-border-' + finding.severity]}
                     title={<>
                         {canOpenFinding
                             ? <Link to={`/vul-source-items/${finding.vulSourceItem?.id}`} style={{color: "black"}}>{findingTitle}</Link>
                             : <span style={{color: "black"}}>{findingTitle}</span>}
                         {isWithdrawnFinding(finding) && <Tag color="red" variant={"filled"} className={styles['withdrawn-finding-tag']}>withdrawn</Tag>}
                     </>}
                     extra={<div className={styles['finding-card-extra']}>
                         <span>{formatDateTime(finding.vulSourceItem?.sourcePublished)}</span>
                         <Button
                             className={"btn-seamless"}
                             size={"small"}
                             icon={<FullscreenOutlined/>}
                             title={"Open distraction-free view"}
                             onClick={event => {
                                 event.stopPropagation();

                                 focusedAnalysis.open(sbomComponent, finding);
                             }}
                         />
                     </div>}>
            <div className={`${tackStyles.tack} ${sealScoreStyles['severity-' + finding.severity]} ${styles['component-findings-tack']}`}/>
            <VulSourceItemPreview
                item={finding.vulSourceItem}
                showTitle={false}
                attributeDefinitions={attributeDefinitions}
                showAiAnalytics={tableUiConfig.showAiAnalytics ?? true}
                framed={true}
            />

            <FindingStatusCollapse sbomProject={sbomProject} finding={finding} onFindingStatusSave={onFindingStatusSave}/>
        </Card>;
    }

    function updateTableUiConfig(uiConfig: TableUiConfig) {
        setTableUiConfig(uiConfig);

        tableHandler.saveUiConfig(uiConfig);
    }

    function isWithdrawnFinding(finding: SbomComponentFinding) {
        return finding.vulSourceItem?.attributes?.withdrawn === true;
    }

    function renderName(value: any, sbomComponent: SbomComponent) {
        return <>
            {value}
            {sbomComponent.purl && <Tag title={`${sbomComponent.purl}`} color={"blue"} className={styles['component-tag']} onClick={event => {
                event.preventDefault();
                event.stopPropagation();

                navigator.clipboard.writeText(sbomComponent.purl);

                message.info("Package URL copied to clipboard.");
            }}>purl</Tag>}
            <SbomComponentSourcePackageTag component={sbomComponent} className={styles['component-tag']}/>
            {sbomComponent.directDependency && <Tag title={"Component is a direct dependency of this project."}>direct</Tag>}
            {sbomComponent.duplicate && <Tag title={"Component is included in this project version multiple times."} color={"orange"}>duplicate</Tag>}
            {sbomComponent.cpe && <Tag title={sbomComponent.cpe} color={"blue"} className={styles['component-tag']} onClick={event => {
                event.preventDefault();
                event.stopPropagation();

                navigator.clipboard.writeText(sbomComponent.cpe);

                message.info("CPE name copied to clipboard.");
            }}>cpe</Tag>}
            <Button size={"small"}
                    style={{marginLeft: 4}}
                    onClick={(e) => {
                        e.stopPropagation();

                        onShowUsagesClick(sbomComponent);
                    }} icon={<ApartmentOutlined/>}
                    title={"Show usages"}
            />
        </>;
    }

    function renderVersion(value: any, sbomComponent: SbomComponent) {
        let purl: PackageURL = null;
        let osiUrl: string = null;
        const latestOsiUrl = createLatestVersionOsiUrl(sbomComponent);

        try {
            purl = PackageURL.fromString(sbomComponent.purl);

            osiUrl = packageUrlToOsiUrl(purl);
        } catch {
        }

        if (sbomComponent.latestVersion && sbomComponent.latestVersion !== sbomComponent.version) {
            if (purl != null) {
                return <>
                    <Link to={osiUrl} target={"_blank"} title={"Open at Open Source Insights"} onClick={e => e.stopPropagation()}>{value}</Link>
                    {" "}
                    <span className={styles['component-update-available']}>
                        <ArrowUpOutlined title={"Update is available."}/>
                        {" "}
                        <Link to={latestOsiUrl}
                              target={"_blank"}
                              title={"Open at Open Source Insights"}
                              onClick={e => e.stopPropagation()}>{sbomComponent.latestVersion}</Link>
                    </span>
                </>;
            } else {
                return <>
                    {value}{" "}
                    <span className={styles['component-update-available']}>
                        <ArrowUpOutlined title={"Update is available."}/>
                        {" "}
                        {sbomComponent.latestVersion}
                    </span>
                </>;
            }
        } else {
            if (packageUrlSupportedByDepsDev(purl)) {
                return <Link to={osiUrl} target={"_blank"} title={"Open at Open Source Insights"} onClick={e => e.stopPropagation()}>{value}</Link>;
            } else {
                return value;
            }
        }
    }

    function createLatestVersionOsiUrl(component: SbomComponent) {
        if (!component.purl || !component.latestVersion) {
            return undefined;
        }

        try {
            const purl = PackageURL.fromString(component.purl);

            purl.version = component.latestVersion;

            return packageUrlToOsiUrl(purl);
        } catch {
            return undefined;
        }
    }

    function renderPublishedAt(value: any, sbomComponent: SbomComponent) {
        if (sbomComponent.publishedAt === undefined) {
            return <i>unknown</i>;
        }

        const health = evaluateSbomComponentHealth(sbomComponent, new Date());

        let color, title;

        switch (health) {
            case SbomComponentHealth.HEALTHY:
                title = "Component is not older than two years.";
                color = green.primary;
                break;
            case SbomComponentHealth.OUT_OF_DATE:
                title = "Component is more than two years old.";
                color = orange.primary;
                break;
            case SbomComponentHealth.OBSOLETE:
                title = "Component is more than four years old.";
                color = red.primary;
                break;
        }

        return <span title={title} style={{color: color}}>
            {formatDate(sbomComponent.publishedAt)}
        </span>;
    }

    function renderLicense(license: SoftwareLicense) {
        if (license.origin === SoftwareLicenseOrigin.UNKNOWN) {
            return <div key={license.name}>{license.name}</div>;
        }

        return <div key={license.name}><Link to={`/software-licenses/${license.id}`} target={"_blank"}>{license.shortName}</Link></div>;
    }

    function renderLicenses(licenses: SoftwareLicense[], component: SbomComponent) {
        if (component.overridenLicenses.length > 0) {
            return <div className={styles['overriden-licenses']}>
                <div>{licenses.map(renderLicense)}</div>
                <div className={styles['overriden-licenses-tooltip']}>
                    <Popover title={"Licenses in SBOM"} content={component.overridenLicenses.map(renderLicense)}>
                        <SwapOutlined/>
                    </Popover>
                </div>
            </div>;
        }

        return <>
            {licenses.map(renderLicense)}
        </>;
    }

    function renderType(value: any, sbomComponent: SbomComponent) {
        if (sbomComponent.purl?.startsWith("pkg:maven")) {
            return <><img src={"/img/Apache_Maven_logo.svg"} style={{width: 40}} title={value}/></>;
        } else if (sbomComponent.purl?.startsWith("pkg:nuget")) {
            return <><img src={"/img/NuGet_logo.svg"} style={{width: 24}} title={value}/></>;
        } else if (sbomComponent.purl?.startsWith("pkg:npm")) {
            return <><img src={"/img/Npm_logo.svg"} style={{width: 32}} title={value}/></>;
        } else if (sbomComponent.purl?.startsWith("pkg:deb/debian")) {
            return <><FaDebian title={"Debian package"} style={{width: 32}} /></>;
        } else if (sbomComponent.purl?.startsWith("pkg:deb/ubuntu")) {
            return <><FaUbuntu title={"Ubuntu debian package"} style={{width: 32}} /></>;
        } else if (sbomComponent.type === 'operating-system') {
            return <span title={"operating system"}>os</span>;
        } else if (sbomComponent.type === 'library') {
            return <span title={"library"}>lib</span>;
        } else if (sbomComponent.type === 'application') {
            return <span title={"application"}>app</span>;
        } else {
            return <>{value}</>;
        }
    }

    function renderAnalysisStatistics(_: any, sbomComponent: SbomComponent) {
        return <FindingAnalysisStatistics analysisStatistics={sbomComponent?.analysisStatistics} style={AnalysisStyle.PROGRESS}/>;
    }

    function renderFindingStatisticsColumn(findingStatistics: any, sbomComponent: SbomComponent) {
        if (!findingStatistics) {
            return <FindingStatisticsImpact findingStatistics={findingStatistics} component={sbomComponent}/>;
        }

        return <span
            className={styles['finding-statistics-action']}
            role={"button"}
            tabIndex={0}
            title={"Open vulnerability analysis"}
            onClick={event => {
                event.stopPropagation();
                focusedAnalysis.focusComponent(sbomComponent);
            }}
            onKeyDown={event => {
                if (event.key !== "Enter" && event.key !== " ") {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
                focusedAnalysis.focusComponent(sbomComponent);
            }}>
            <FindingStatisticsImpact findingStatistics={findingStatistics} component={sbomComponent}/>
        </span>;
    }

    function renderAction(_: any, component: SbomComponent) {
        const items: MenuProps['items'] = [
            {
                label: 'Analyze findings',
                key: 'analyze-findings',
                icon: <FullscreenOutlined/>,
                disabled: !component.findingStatistics
            },
            {
                label: 'Override license',
                key: 'override-license'
            }
        ];

        const onClick: MenuProps['onClick'] = (e) => {
            e.domEvent.stopPropagation();

            switch (e.key) {
                case 'analyze-findings':
                    focusedAnalysis.focusComponent(component);
                    break;
                case 'override-license':
                    if (component.purl === undefined || component.purl === '') {
                        return;
                    }

                    const atIndex = component.purl.indexOf('@');

                    const searchParams = new URLSearchParams();

                    searchParams.set("purl", component.purl.substring(0, atIndex));
                    searchParams.set("vers", component.version);

                    if (appContext.user.isSystemAdmin()) {
                        searchParams.set("organizationId", sbomProjectVersion.project.organization.id);
                    }

                    window.open(`/software-license-overrides/add?${searchParams.toString()}`, "_blank");
                    break;
            }
        };

        return (
            <>
                <Dropdown menu={{items, onClick}} trigger={["click"]}>
                    <Button icon={<MenuOutlined/>} onClick={e => e.stopPropagation()}/>
                </Dropdown>
            </>
        );
    }

    function renderComponents(filterState: ComponentFilterState, debounceCallback: any, tableHandler: TableHandler, components: PagedResult<SbomComponent>, persistentStateIdent: string, customFilterComponent?: any) {
        const {values: filterValues, setValues: setFilterValues} = filterState;

        const filterComponent = (customFilterComponent !== undefined)
            ? customFilterComponent
            : <SbomProjectVersionComponentFilter
                className={styles['filter']}
                values={filterValues}
                onChange={values => {
                    if (_.isEqual(values, filterValues)) {
                        return;
                    }

                    setFilterValues(values);

                    debounceCallback(values);
                }}
                persistentStateIdent={persistentStateIdent}
                immediateMode={tableUiConfig.immediateMode}
            />;

        return <>
            {filterComponent}

            <div className={globalStyles["common__top-button-bar"]}>
                <Button className={"btn-seamless"} icon={<ReloadOutlined/>} title={"Reload"} onClick={tableHandler.reload}/>

                <TableConfig
                    columns={columns}
                    value={tableUiConfig}
                    showAiAnalyticsOption={true}
                    onChange={updateTableUiConfig}
                />
            </div>

            <Table className={styles.table}
                   showSorterTooltip={false}
                   loading={tableHandler.loading}
                   dataSource={components?.data}
                   size="middle"
                   onChange={tableHandler.onTableChange}
                   pagination={tableHandler.pagination}
                   rowKey="id"
                   expandable={{
                       showExpandColumn: true,
                       expandRowByClick: true,
                       rowExpandable: hasVulnerabilityFindings,
                       onExpand: onExpandComponent,
                       expandedRowRender: renderExpandedComponent
                   }}
                   columns={columns.filter(column => isColumnVisible(tableUiConfig.visibleColumns, column))}
            />
        </>;
    }

    function renderActiveComponentTab(tabKey: string, renderContent: () => React.ReactNode) {
        const currentTab = activeComponentsTab ?? getAvailableComponentTabs(sbomProjectVersion)[0];

        return currentTab === tabKey ? renderContent() : null;
    }

    function onShowUsagesClick(sbomComponent: SbomComponent) {
        sbomComponentService.getUnovisGraph(sbomComponent.id)
            .then(response => {
                if (response.status === 204) {
                    message.info("Usage graph is not available for this component.");

                    return;
                }

                setUsageModalTitle(`Usage of ${sbomComponent.bomRef}`);
                setUsageGraphData(response.data);
                setUsageModalOpen(true);
            });
    }

    function onExpandComponent(expanded: boolean, sbomComponent: SbomComponent) {
        if (expanded === false) {
            return;
        }

        if (focusedAnalysis.componentsFindings[sbomComponent.id] === undefined) {
            focusedAnalysis.reloadComponentFindings(sbomComponent.id);
        }
    }

    function hasVulnerabilityFindings(sbomComponent: SbomComponent) {
        return Object.keys(sbomComponent.findingStatistics ?? {}).length > 0;
    }

    function onDownloadBom() {
        window.location.href = `/api/sbom-project-versions/${sbomProjectVersionIdRef.current}/sbom`;
    }

    function onFinishFilter(values: any) {
        filterFormPersisters.all.saveState(values);

        tableHandler.onRqbSearchSubmit(createRqbQuery(values));
    }

    function onFinishVulnerableFilter(values: any) {
        filterFormPersisters.vulnerable.saveState(values);

        vulnerableTableHandler.onRqbSearchSubmit(createRqbQuery(values));
    }

    function onFinishDuplicateFilter(values: any) {
        filterFormPersisters.duplicate.saveState(values);

        duplicateTableHandler.onRqbSearchSubmit(createRqbQuery(values));
    }

    function onFinishUnknownLicensesFilter(values: any) {
        filterFormPersisters.unknownLicenses.saveState(values);

        unknownLicensesTableHandler.onRqbSearchSubmit(createRqbQuery(values));
    }

    function onFinishOutdatedFilter(values: any) {
        filterFormPersisters.outdated.saveState(values);

        outdatedTableHandler.onRqbSearchSubmit(createRqbQuery(values));
    }

    function restoreFilterQueries() {
        restoreRqbSearch(tableHandler, filterValues);
        restoreRqbSearch(vulnerableTableHandler, vulnerableFilterValues, vulnerableComponentsFixedRqbQuery);
        restoreRqbSearch(duplicateTableHandler, duplicateFilterValues, duplicateComponentsFixedRqbQuery);
        restoreRqbSearch(unknownLicensesTableHandler, unknownLicensesFilterValues, unknownLicensesFixedRqbQuery);
        restoreRqbSearch(outdatedTableHandler, outdatedFilterValues, outdatedComponentsFixedRqbQuery);
    }

    function loadFilterValues(filterFormPersister: FormPersister, defaultValues: any) {
        const values = filterFormPersister.loadValues();

        return _.isEmpty(values) ? defaultValues : values;
    }

    function restoreRqbSearch(tableHandler: TableHandler, values: any, fixedRqbQuery?: any) {
        const rqbQuery = createRqbQuery(values);

        tableHandler.queryOptions.rqbQuery = fixedRqbQuery
            ? {combinator: "and", rules: [fixedRqbQuery, rqbQuery]}
            : rqbQuery;
        tableHandler.queryOptions.skip = 0;
    }

    function onDeleteConfirm() {
        sbomProjectVersionService.delete(sbomProjectVersion)
            .then(() => {
                message.success(<>Project version <b>{sbomProjectVersion.name}</b> successfully deleted.</>);

                navigate(`/sbom-projects/${sbomProjectVersion.project.id}`);
            });
    }

    function onFindingStatusSave(finding: SbomComponentFinding) {
        const findingsPage = focusedAnalysis.componentsFindings[finding.component.id];

        reloadActiveComponents();

        focusedAnalysis.reloadComponentFindings(finding.component.id, findingsPage?.skip ?? 0, findingsPage?.sort);
        focusedAnalysis.reloadNavigationIfModalOpen();
    }

    function onEvaluationCompleted() {
        message.success('Evaluation of components completed.');

        reloadActiveComponents();
        focusedAnalysis.reloadNavigationIfModalOpen();
    }

    function onPublishedAtUpdateCompleted() {
        reloadComponentsByTab(activeComponentsTabRef.current);
    }

    function onFindingsUpdated() {
        reloadActiveComponents();
        reloadExpandedComponentFindings();
        focusedAnalysis.reloadNavigationIfModalOpen();
    }

    function reloadActiveComponents(preferHashTab: boolean = false) {
        return reload(preferHashTab).then(projectVersion => reloadComponentsByTab(resolveActiveComponentsTab(projectVersion)));
    }

    function reloadComponentsByTab(tabKey: string | undefined) {
        switch (tabKey) {
            case SBOM_VULNERABLE_TAB_HASH:
                vulnerableTableHandler.reload();
                break;
            case "duplicate":
                duplicateTableHandler.reload();
                break;
            case "unknownLicenses":
                unknownLicensesTableHandler.reload();
                break;
            case "outdated":
                outdatedTableHandler.reload();
                break;
            case "all":
            default:
                tableHandler.reload();
                break;
        }
    }

    function clearComponentData() {
        setSbomComponents(undefined);
        setVulnerableSbomComponents(undefined);
        setDuplicateComponents(undefined);
        setUnknownLicensesComponents(undefined);
        setOutdatedComponents(undefined);
    }

    function reload(preferHashTab: boolean = false) {
        return sbomProjectVersionService.get(sbomProjectVersionIdRef.current).then(projectVersion => {
            setSbomProjectVersion(projectVersion);

            sbomProjectService.get(projectVersion.project.id).then(setSbomProject);

            const hashTab = location.hash !== '' ? location.hash.substring(1) : undefined;

            if (hashTab && knownConditionalComponentTabs.includes(hashTab) && !getAvailableComponentTabs(projectVersion).includes(hashTab)) {
                navigate(location.pathname, {replace: true});
            }

            const activeTab = resolveActiveComponentsTab(projectVersion, preferHashTab);

            setCurrentComponentsTab(activeTab);

            return projectVersion;
        });
    }

    function onComponentsTabChange(tabKey: string) {
        setCurrentComponentsTab(tabKey);
        reloadComponentsByTab(tabKey);
    }

    function setCurrentComponentsTab(tabKey: string) {
        activeComponentsTabRef.current = tabKey;
        setActiveComponentsTab(tabKey);
    }

    function resetCurrentComponentsTab() {
        activeComponentsTabRef.current = undefined;
        setActiveComponentsTab(undefined);
    }

    function resolveActiveComponentsTab(projectVersion?: SbomProjectVersion, preferHashTab: boolean = false) {
        const availableTabs = getAvailableComponentTabs(projectVersion);

        if (preferHashTab) {
            const hashTab = location.hash !== '' ? location.hash.substring(1) : undefined;

            if (hashTab && availableTabs.includes(hashTab)) {
                return hashTab;
            }
        }

        const currentTab = activeComponentsTabRef.current;

        return currentTab && availableTabs.includes(currentTab) ? currentTab : availableTabs[0];
    }

    function getAvailableComponentTabs(projectVersion?: SbomProjectVersion) {
        const tabs = [];

        if (projectVersion?.componentsVulnerable > 0) {
            tabs.push(SBOM_VULNERABLE_TAB_HASH);
        }

        if (projectVersion?.componentsDuplicate > 0) {
            tabs.push("duplicate");
        }

        if (projectVersion?.componentsUnknownLicenses > 0) {
            tabs.push("unknownLicenses");
        }

        if (projectVersion?.componentsOutdated > 0) {
            tabs.push("outdated");
        }

        tabs.push("all");

        return tabs;
    }

    function evaluateComponents() {
        sbomComponentService.evaluateComponents(sbomProjectVersionId)
            .then(() => {
                message.success("Evaluation of components queued successfully. Evaluation will be completed shortly.", 5);
            })
            .catch(() => {
                message.error("Components evaluation failed.");
            });
    }

    function handleImport(params: any) {
        const {file} = params;

        const reader = new FileReader();

        reader.onloadend = () => {
            if (typeof reader.result === "string") {
                sbomComponentService.importCycloneDxJsonBom(sbomProjectVersionId, reader.result, file.type)
                    .then(() => {
                        message.success("SBOM imported successfully. Evaluation of vulnerable components will be completed shortly.", 5);

                        reloadActiveComponents();
                    })
                    .catch(() => {
                        message.error("Import of SBOM failed.");
                    });

            } else {
                message.error("Cannot load JSON document.");
            }
        };

        reader.readAsText(file, "UTF-8");
    }

    function reloadComponents() {
        return sbomComponentService.getList(sbomProjectVersionIdRef.current, tableHandler.queryOptions).then(components => {
            tableHandler.updateTotal(components.total);

            setSbomComponents(components);

            reloadExpandedComponentFindings();
        });
    }

    function reloadExpandedComponentFindings() {
        focusedAnalysis.reloadExpandedComponentFindings();
    }

    function reloadVulnerableComponents() {
        return sbomComponentService.getList(sbomProjectVersionIdRef.current, vulnerableTableHandler.queryOptions).then(components => {
            vulnerableTableHandler.updateTotal(components.total);

            setVulnerableSbomComponents(components);
        });
    }

    function reloadDuplicateComponents() {
        return sbomComponentService.getList(sbomProjectVersionIdRef.current, duplicateTableHandler.queryOptions).then(components => {
            duplicateTableHandler.updateTotal(components.total);

            setDuplicateComponents(components);
        });
    }

    function reloadUnknownLicenseComponents() {
        return sbomComponentService.getList(sbomProjectVersionIdRef.current, unknownLicensesTableHandler.queryOptions).then(components => {
            unknownLicensesTableHandler.updateTotal(components.total);

            setUnknownLicensesComponents(components);
        });
    }

    function reloadOutdatedComponents() {
        return sbomComponentService.getList(sbomProjectVersionIdRef.current, outdatedTableHandler.queryOptions).then(components => {
            outdatedTableHandler.updateTotal(components.total);

            setOutdatedComponents(components);
        });
    }

}

interface ActionsDropdownProps {
    canManage?: boolean;
    canAnalyze?: boolean;
    canRead?: boolean;
    sbomProjectVersion?: SbomProjectVersion;
    onEdit: () => void;
    onDelete: () => void;
    onImport: (options: any) => void;
    onDownload: () => void;
    onEvaluate: () => void;
    onAdopt: () => void;
    onCompare: () => void;
}

const ActionsDropdown = memo(function ({canManage, canAnalyze, canRead, sbomProjectVersion, onEdit, onDelete, onImport, onDownload, onEvaluate, onAdopt, onCompare}: ActionsDropdownProps) {
    const menuItems: MenuProps['items'] = [];

    if (canManage) {
        menuItems.push({key: 'import', icon: <UploadOutlined />, label: <Upload accept="application/json,text/xml" showUploadList={false} customRequest={onImport}>Import SBOM</Upload>});
    }

    if (canRead && sbomProjectVersion?.sbomImportedAt) {
        menuItems.push({key: 'download', icon: <DownloadOutlined />, label: "Download SBOM"});
    }

    if (canAnalyze || canManage) {
        if (menuItems.length > 0) {
            menuItems.push({type: 'divider'});
        }

        menuItems.push({key: 'evaluate', icon: <ReloadOutlined />, label: "Evaluate components"});
        menuItems.push({key: 'adopt', icon: <SwapOutlined />, label: "Adopt analysis"});
    }

    if ((canAnalyze || canManage) && sbomProjectVersion?.comparable) {
        menuItems.push({key: 'compare', icon: <BranchesOutlined />, label: "Compare"});
    }

    const onClick: MenuProps['onClick'] = ({key}) => {
        switch (key) {
            case 'download':
                onDownload();
                break;
            case 'evaluate':
                onEvaluate();
                break;
            case 'adopt':
                onAdopt();
                break;
            case 'compare':
                onCompare();
                break;
        }
    };

    return <div className={globalStyles["common__top-button-bar"]}>
        {canManage && <>
            <Button onClick={onEdit}>Edit</Button>
            <Button danger={true} onClick={onDelete}>Delete</Button>
        </>}
        {menuItems.length > 0 &&
            <Dropdown menu={{items: menuItems, onClick}} trigger={["click"]}>
                <Button>More actions <DownOutlined style={{fontSize: 10}}/></Button>
            </Dropdown>
        }
    </div>;
});

interface MoreInfoPanelProps {
    sbomProjectVersion?: SbomProjectVersion;
    canManage?: boolean;
    open?: boolean;
}

interface HeaderTitleProps {
    sbomProjectVersion?: SbomProjectVersion;
}

interface HeaderCardsProps {
    sbomProjectVersion?: SbomProjectVersion;
    actionsDropdown?: React.ReactNode;
    moreInfoOpen?: boolean;
    onToggleMoreInfo?: () => void;
}

const MoreInfoPanel = memo(function ({sbomProjectVersion, canManage, open}: MoreInfoPanelProps) {
    return <Collapse isOpen={open}>
        <div className={styles['more-info-panel']}>
            <div className={styles['header-card-label']}>More info</div>
            <Descriptions column={2} size="small" className={styles['details-descriptions']}>
                <Descriptions.Item label={"SBOM format"}>
                    {formatSbomType(sbomProjectVersion?.sbomType, sbomProjectVersion?.sbomTypeVersion)}
                </Descriptions.Item>
                <Descriptions.Item label={"SBOM generated at"}>
                    {formatDateTime(sbomProjectVersion?.sbomGeneratedAt) || <i>never</i>}
                </Descriptions.Item>
                {canManage && <Descriptions.Item label={"Suppress in reports"} span={2}>
                    <Checkbox checked={sbomProjectVersion?.suppressInReports} disabled={true}/>
                </Descriptions.Item>}
                <Descriptions.Item label={"Licenses"} span={2}>
                    <ProjectVersionLicenses sbomProjectVersion={sbomProjectVersion}/>
                </Descriptions.Item>
            </Descriptions>
        </div>
    </Collapse>;
});

const HeaderTitle = memo(function ({sbomProjectVersion}: HeaderTitleProps) {
    const showStatusTag = sbomProjectVersion?.status === SbomProjectVersionStatus.WAITING_FOR_SBOM
        || sbomProjectVersion?.status === SbomProjectVersionStatus.WAITING_FOR_EVALUATION
        || sbomProjectVersion?.status === SbomProjectVersionStatus.NOT_VULNERABLE;
    const hasLicenseViolation = sbomProjectVersion?.licenseViolations?.length > 0;

    return <h1 className={styles.title}>
        <span className={styles['title-text']}>{sbomProjectVersion?.project?.name}: <b>{sbomProjectVersion?.name}</b></span>
        {hasLicenseViolation && <Tag color="orange" style={{borderColor: orange[5]}}>License violation</Tag>}
        {showStatusTag && <Tag color={colorForSbomProjectVersionStatus(sbomProjectVersion.status)}>
            {formatSbomProjectVersionStatus(sbomProjectVersion.status)}
        </Tag>}
    </h1>;
});

const HeaderCards = memo(function ({sbomProjectVersion, actionsDropdown, moreInfoOpen, onToggleMoreInfo}: HeaderCardsProps) {
    const findingSummary = sbomProjectVersion?.findingSummary;
    const findingStatistics = findingSummary?.uniqueFindingStatistics ?? {};
    const analysedFindingStatistics = findingSummary?.analysedUniqueFindingStatistics ?? {};
    const hasAnalysisImpact = findingSummary?.occurrenceCount !== findingSummary?.analysedOccurrenceCount;
    const hasFindings = Object.keys(findingStatistics).length > 0;
    const showFindings = hasFindings || sbomProjectVersion?.status === SbomProjectVersionStatus.NOT_VULNERABLE;
    const hasAnalysis = sbomProjectVersion?.analysisStatistics != null
        && Object.values(sbomProjectVersion.analysisStatistics).some((v: any) => v > 0);
    const hasInfo = !!sbomProjectVersion;

    const metadataItems: Array<{ label: string, value: React.ReactNode }> = [];

    if (sbomProjectVersion?.projectType) {
        metadataItems.push({label: 'Project type', value: sbomProjectVersion.projectType});
    }

    if (sbomProjectVersion?.sbomImportedAt) {
        metadataItems.push({label: 'Imported', value: formatDateTime(sbomProjectVersion.sbomImportedAt)});
    }

    if (sbomProjectVersion?.componentEvaluatedAt) {
        metadataItems.push({label: 'Last evaluated', value: formatDateTime(sbomProjectVersion.componentEvaluatedAt)});
    }

    if (sbomProjectVersion?.tags?.length > 0) {
        metadataItems.push({
            label: 'Tags',
            value: <span className={styles['metadata-tags']}>
                {sbomProjectVersion.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
            </span>
        });
    }

    if (!showFindings && !hasAnalysis && !hasInfo && !actionsDropdown) {
        return null;
    }

    return <div className={styles['header-cards']}>
        {hasInfo && <div className={styles['header-card']}>
            <div className={styles['header-card-label']}>Info</div>
            {metadataItems.length > 0 && <div className={styles['metadata-grid']}>
                {metadataItems.map(item => <React.Fragment key={item.label}>
                    <span className={styles['metadata-label']}>{item.label}:</span>
                    <span className={styles['metadata-value']}>{item.value}</span>
                </React.Fragment>)}
            </div>}
            <Button className={styles['more-info-toggle']} size={"small"} type={"link"} onClick={onToggleMoreInfo}>
                {moreInfoOpen ? '» show less «' : '« show more »'}
            </Button>
        </div>}

        {hasAnalysis && <div className={styles['header-card']}>
            <div className={styles['header-card-label']}>Findings analysis</div>
            <div className={styles['header-card-content']}>
                <FindingAnalysisStatistics analysisStatistics={sbomProjectVersion.analysisStatistics} style={AnalysisStyle.INLINE}/>
            </div>
        </div>}

        {showFindings && findingSummary && <div className={styles['header-card']}>
            <div className={styles['header-card-label']}><VulnerabilitiesLabel/></div>
            {!hasAnalysisImpact ? (
                <div className={styles['header-card-content-stack']}>
                    <div className={styles['header-card-content']}>
                        <FindingStatistics findingStatistics={findingStatistics}/>
                    </div>
                    <FindingCount
                        count={findingSummary.occurrenceCount}
                        componentCount={findingSummary.componentCount}
                        className={styles['findings-count']}/>
                </div>
            ) : (
                <div className={styles['header-card-content-stack']}>
                    <div>
                        <div className={styles['findings-analysis-label']}>Before analysis</div>
                        <FindingStatistics findingStatistics={findingStatistics}/>
                        <FindingCount
                            count={findingSummary.occurrenceCount}
                            componentCount={findingSummary.componentCount}
                            className={styles['findings-count']}/>
                    </div>
                    <div>
                        <div className={styles['findings-analysis-label']}>After analysis</div>
                        <FindingStatistics findingStatistics={analysedFindingStatistics}/>
                        <FindingCount
                            count={findingSummary.analysedOccurrenceCount}
                            componentCount={findingSummary.analysedComponentCount}
                            className={styles['findings-count']}/>
                    </div>
                </div>
            )}
        </div>}

        {actionsDropdown && <div className={styles['header-card']}>
            <div className={styles['header-card-label']}>Actions</div>
            <div className={styles['header-card-content']}>
                {actionsDropdown}
            </div>
        </div>}
    </div>;
});

interface EditFormProps {
    sbomProjectVersion?: SbomProjectVersion;
    editMode: boolean;
    onCancel: () => void;
    onFinish: () => void;
}

const EditForm = memo(function ({sbomProjectVersion, editMode, onCancel, onFinish}: EditFormProps) {
    const sbomProjectVersionService = useContext(SbomProjectVersionServiceContext);
    const [editForm] = useForm();

    useEffect(() => {
        editForm.setFieldsValue(sbomProjectVersion);
    }, [sbomProjectVersion]);

    return <Collapse isOpen={editMode}>
        <h3>Edit of project version {sbomProjectVersion?.name} of project {sbomProjectVersion?.project?.name}</h3>

        <Form {...layout} form={editForm} className={`${globalStyles["common__form"]} ${globalStyles["common_form--edit"]}`} onFinish={onFinishEdit}>
            <Form.Item
                name={"name"}
                label={"Name"}
                rules={[
                    {required: true, message: "Name is required."},
                    {validator: serverViolationsHolder.createServerValidator('UNIQUE', 'name, project_id', undefined, {compareLowerCaseValues: true}), message: "Name is already used."}
                ]}>
                <Input maxLength={100}/>
            </Form.Item>

            <Form.Item
                name={["tags"]}
                label={"Tags"}>
                <Select mode="tags"/>
            </Form.Item>

            <Form.Item
                name={"suppressInReports"}
                label={"Suppress in reports"}
                valuePropName={"checked"}>
                <Switch/>
            </Form.Item>

            <Form.Item {...tailLayout} className={globalStyles["common__form-buttons"]}>
                <Button type={"primary"} htmlType={"submit"}>{"Save"}</Button>
                <Button onClick={onCancel}>{"Cancel"}</Button>
            </Form.Item>
        </Form>
    </Collapse>;

    function onFinishEdit(values: any) {
        sbomProjectVersionService.update(sbomProjectVersion.id, values)
            .then(
                () => {
                    message.success(<>Project version <b>{values.name}</b> successfully updated.</>);

                    onFinish();
                },
                error => serverViolationsHolder.handleServerError(error, editForm)
            );
    }
});

interface ComponentTabsProps {
    items: TabsProps['items'];
    activeKey?: string;
    onChange: (key: string) => void;
}

const ComponentTabs = function ({items, activeKey, onChange}: ComponentTabsProps) {
    const location = useLocation();
    const navigate = useNavigate();
    const defaultTab = items?.[0]?.key ?? "all";

    return <Tabs
        style={{marginTop: 8}}
        items={items}
        animated={false}
        activeKey={activeKey ?? defaultTab}
        onChange={key => {
            navigate(`${location.pathname}${location.search}#${key}`, {replace: true});

            onChange(key);
        }}
    />;
};

export default SbomProjectVersionDetail;
